module.exports = __webpack_public_path__ + "img/w3.c4746dc9.png";